import React, { memo, useEffect, useMemo, useState } from "react";
import PieChart from "./common/PieChart";
import LineChart from "./common/LineChart";
import VerticalBarChart from "./common/VerticalBarChart";
import StackedBarChart from "./common/StackedBarChart";
import DonutChart from "./common/DonutChart";
import ProgressChart from "./common/ProgressChart";
import GroupedColumnChart from "./common/GroupedColumnChart";
import { ReactComponent as DashboardIcon } from "../../../../assets/svgs/dashboardn.svg";
import { ReactComponent as Product1 } from "../../../../assets/svgs/product11.svg";
import { ReactComponent as Product2 } from "../../../../assets/svgs/product22.svg";
import { ReactComponent as Product3 } from "../../../../assets/svgs/product33.svg";
import { ReactComponent as Product4 } from "../../../../assets/svgs/Product44.svg";
import { ReactComponent as Eng1 } from "../../../../assets/svgs/energys1.svg";
import { ReactComponent as Eng2 } from "../../../../assets/svgs/energys2.svg";
import { ReactComponent as Scope3 } from "../../../../assets/svgs/Scope3.svg";
import CarbonCard from "./common/CarbonCard";
import CarbonSmallCard from "./common/CarbonSmallCard";
import BarChart from "./common/BarChart";
import ScopeWiseFootprint from "./common/ScopeWiseFootPrint";
import LabelValueCard from "./common/LabelValueCard";
//import Footer from "./common/Footer";
import HorizontalBarChart from "./common/HorizontalBarChart";
import { ReactComponent as Mobliefuel1 } from "../../../../assets/svgs/mobliefuel111.svg";
import { ReactComponent as Moblefuel2 } from "../../../../assets/svgs/moblefuel222.svg";
import { ReactComponent as Icon3 } from "../../../../assets/svgs/emissiontracking33.svg";
import { ReactComponent as Monthwise11 } from "../../../../assets/svgs/monthwise101.svg";
import { ReactComponent as Monthwise22 } from "../../../../assets/svgs/monthwise202.svg";

import { ReactComponent as Monthwise1 } from "../../../../assets/svgs/Monthwise1.svg";

import { ReactComponent as Scopemonth } from "../../../../assets/svgs/scopemonths.svg";

import { ReactComponent as Monthwise2 } from "../../../../assets/svgs/Monthwise22223.svg";

import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
import TimeFilterBar from "./TimeFilterBar";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as Waterfootprint } from "../../../../assets/svgs/waterfootprints.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PermissionForm from "../../../Auth/PermissionForm";
import { getApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import {
  fetchAllDepartments,
  fetchAllLocations,
} from "../../../../redux/OrganizationSetup/organizationSetupSlice";

const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const DUMMY_COMPONENTS = {
  total_carbon_footprint: {
    title: "Total Carbon Footprint",
    displayOptions: { unit: "Mtco2e", label: "Total Carbon Footprint" },
    data: { value: 14899.1 },
  },
  total_water_footprint: {
    title: "Total Water Footprint",
    displayOptions: { unit: "Kilolitres", label: "Total Water Footprint" },
    data: { value: 434484.75 },
  },
  scope_wise_footprint: {
    title: "Scope Wise Footprint",
    displayOptions: { unit: "MtCO2e", showPercentage: true },
    data: {
      labels: ["Scope 1", "Scope 2", "Scope 3"],
      values: [976.6, 12367.5, 1555.0],
      percentages: [6.5, 83.0, 10.5],
      total: 14899.1,
    },
  },
  monthwise_water_footprint: {
    title: "Month-wise Water Footprint",
    displayOptions: {
      unit: "Litres",
      xAxis: "Month",
      yAxis: "Water Consumption",
    },
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      values: [
        12314, 13202, 14260, 5948, 5843, 8316, 6140, 6868, 5278, 6837, 13053,
        13353,
      ],
    },
  },
  scope_1_2_pie: {
    title: "Scope 1 & 2",
    displayOptions: { showPercentage: true },
    data: [
      { group: "Purchased Electricity", value: 6904.3, percentage: 46.34 },
      { group: "Fugitive emissions", value: 457.4, percentage: 3.07 },
      { group: "Stationary Fuel Consumption", value: 436.5, percentage: 2.93 },
      { group: "Mobile Fuel Combustion", value: 196.7, percentage: 1.32 },
      { group: "Purchased Heat & Steam", value: 6904.3, percentage: 46.34 },
    ],
  },
  monthwise_business_travel: {
    title: "Month-wise Emission from Business Travel",
    displayOptions: { unit: "Mtco2e", xAxis: "Month", yAxis: "Emission" },
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "By Air",
          data: [5, 22, 27.5, 2.5, 6.1, 8.7, 12.3, 7, 16, 3.9, 14.1, 20.0],
        },
        {
          label: "By Road",
          data: [2.9, 10.2, 11, 1.6, 3.8, 4.6, 4, 4.5, 6.8, 2.8, 5, 9.3],
        },
        {
          label: "By Train",
          data: [1.3, 6.5, 5, 0.8, 1.5, 2, 3.2, 2, 3.5, 1.2, 3.6, 6],
        },
        {
          label: "By Water",
          data: [1.3, 6.4, 6.5, 0.4, 1.3, 2.8, 3, 1.5, 1, 1, 2.5, 4.2],
        },
      ],
    },
  },
  monthwise_vehicle_fuel: {
    title: "Month-wise Emission from Vehicle Fuel Usage",
    displayOptions: { unit: "MtCO2e", xAxis: "Month", yAxis: "Emission" },
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "Petrol",
          data: [4.8, 4.5, 5, 4.1, 4.9, 5.7, 5.5, 6.8, 7, 7.6, 6.1, 5.4],
        },
        {
          label: "Diesel",
          data: [4.2, 3.3, 3.5, 3.2, 3, 4, 3.5, 3.9, 4.8, 5, 4.1, 4.3],
        },
        {
          label: "CNG",
          data: [2.4, 2, 2.2, 2.2, 2.5, 2.4, 2.2, 2.6, 2.2, 2.8, 2.7, 2.1],
        },
        {
          label: "Other",
          data: [0.9, 1.2, 0.7, 0.6, 0.9, 1.1, 1.2, 1.3, 1.5, 1.4, 1.1, 1.2],
        },
      ],
    },
  },
  monthwise_stationary_fuel: {
    title:
      "Month wise Emission from Cooking/Power generators/Agriculture Fuel/ Other Fuel Usage",
    displayOptions: { unit: "Mtco2e", xAxis: "Month", yAxis: "Emission" },
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "LPG",
          data: [
            12, 15.7, 15.5, 12, 13.7, 15.2, 11.6, 16.5, 15.1, 17.8, 16.2, 14.3,
          ],
        },
        {
          label: "PNG",
          data: [
            11.5, 11.2, 12.6, 9.4, 11, 11.8, 10.2, 12.1, 12.9, 13, 12.4, 10.9,
          ],
        },
        {
          label: "Other",
          data: [5.5, 7.1, 6.9, 5.4, 5.4, 6.5, 5.5, 7.6, 6.7, 6.6, 7, 6.7],
        },
      ],
    },
  },
  monthwise_renewable_savings: {
    title: "Month-wise Emission Savings from Onsite Renewable Power Generation",
    displayOptions: {
      unit: "Mtco2e",
      xAxis: "Month",
      yAxis: "Emission Savings",
    },
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "Solar",
          data: [31, 29.5, 26, 18.5, 20.2, 35, 44.5, 52, 50.5, 44, 38.5, 33.7],
        },
        {
          label: "Wind",
          data: [39.2, 43.3, 49, 39, 39.5, 38.2, 36, 36, 36, 34.8, 36.9, 37],
        },
        {
          label: "Other",
          data: [
            9.4, 12.2, 12.3, 10.5, 12.6, 11.9, 12.5, 12.4, 12, 11.8, 11, 9.4,
          ],
        },
      ],
    },
  },
  monthwise_heating_cooling: {
    title: "Emission from Heating & Cooling System by Category",
    type: "kpi_multi",
    displayOptions: { unit: "MtCO2e" },
    data: {
      datasets: [
        {
          label: "Cooling - Operational",
          value: 6500,
        },
        {
          label: "Cooling - Installed",
          value: 8500,
        },
        {
          label: "Cooling - Discarded",
          value: 5000,
        },
        {
          label: "Heating - Operational",
          value: 7000,
        },
        {
          label: "Heating - Installed",
          value: 6500,
        },
        {
          label: "Heating - Discarded",
          value: 4500,
        },
      ],
    },
  },
  monthwise_refrigerator: {
    title: "Emission from Refrigerator by Category",
    type: "kpi_multi",
    displayOptions: { unit: "MtCO2e" },
    data: {
      datasets: [
        {
          label: "Operational",
          value: 6005,
        },
        {
          label: "Installed",
          value: 8500,
        },
        {
          label: "Discarded",
          value: 4500,
        },
      ],
    },
  },
  monthwise_purchased_electricity: {
    title: "Month-wise Emission from Purchased Electricity",
    displayOptions: {
      unit: "Mtco2e",
      xAxis: "Month",
      yAxis: "Emission",
    },
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "Grid Electricity",
          data: [525, 430, 645, 520, 475, 482, 410, 456, 530, 610, 595, 505],
        },
      ],
    },
  },
  monthwise_heat_steam: {
    title: "Month-wise Emission from Purchased Heat & Steam",
    displayOptions: { unit: "Mtco2e", xAxis: "Month", yAxis: "Emission" },
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "Heat & Steam",
          data: [520, 475, 482, 411, 455, 530, 610, 595, 505, 525, 430, 645],
        },
      ],
    },
  },
  t_and_d_loss: {
    title: "T & D LOSS",
    displayOptions: { unit: "%", label: "T & D Loss" },
    data: { value: "18%" },
  },
  lca_ring: {
    title: "LCA (Total Products vs LCA Till Date)",
    displayOptions: { label: "LCA Coverage" },
    data: { totalProducts: 10, lcaDone: 4, percentage: 40, remaining: 6 },
  },
  clean_energy_ring: {
    title: "Clean Energy (Target vs Achievement)",
    displayOptions: { label: "Clean Energy" },
    data: { target: 100, achievement: 45, percentage: 45, gap: 55 },
  },
  employee_emission_intensity: {
    title: "Employee Emission Intensity",
    displayOptions: {
      unit: "Mtco2e/employee",
      label: "Employee Emission Intensity",
    },
    data: { totalEmissions: 14899.1, denominator: 598, intensity: 24.91 },
  },
  area_emission_intensity: {
    title: "Area Emission Intensity",
    displayOptions: { unit: "Mtco2e/sq.ft", label: "Area Emission Intensity" },
    data: { totalEmissions: 14899.1, denominator: 12458160, intensity: 52 },
  },
  revenue_emission_intensity: {
    title: "Revenue Emission Intensity",
    displayOptions: { unit: "Mtco2e/crore" },
    data: { totalEmissions: 14899.1, denominator: 361.58, intensity: 41.2 },
  },
  product_emission_intensity: {
    title: "Product Emission Intensity",
    displayOptions: {
      unit: "Mtco2e/product",
      label: "Product Emission Intensity",
    },
    data: { totalEmissions: 14899.1, denominator: 0, intensity: 0 },
  },
  scope_3_horizontal_bar: {
    title: "Scope 3",
    displayOptions: { unit: "Mtco2e", showPercentage: true },
    data: {
      labels: [
        "Upstream Transportation",
        "Waste generated in Operations",
        "Business travel",
        "Employee commuting",
        "Downstream transportation & distribution",
      ],
      values: [146.4, 37, 283.9, 1079.2, 8.5],
      percentages: [9.42, 2.38, 18.26, 69.4, 0.55],
      total: 1555,
    },
  },
};

const EmissionDashboard = () => {
  const [showPermission, setPermission] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [activeDashboard, setActiveDashboard] = useState(() => {
    return sessionStorage.getItem("hideDummy") === "true" ? "live" : "dummy";
  });
  const [loading, setLoading] = useState(() => {
    return sessionStorage.getItem("hideDummy") === "true";
  });
  const { user, selectedGroupMember } = useSelector((state) => state.auth);
  const { locationList, departmentList } = useSelector(
    (state) => state.orgSetup,
  );
  const [locationFilter, setLocationFilter] = useState(undefined);
  const [departmentFilter, setDepartmentFilter] = useState(undefined);
  const [yearFilter, setYearFilter] = useState(() =>
    user?.reportingYearType === "calendar" ? "2026" : "2026-2027",
  );
  const isPermissionCompleted = user?.isCompleted;
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const selectedMemberId =
    typeof selectedGroupMember === "string"
      ? selectedGroupMember
      : selectedGroupMember?.clientId ||
        selectedGroupMember?._id ||
        selectedGroupMember?.client_id?._id ||
        selectedGroupMember?.client_id;

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (activeDashboard !== "live") {
        setLoading(false);
        setDashboardData(null);
        return;
      }

      try {
        setLoading(true);
        let apiUrl;

        if (selectedMemberId) {
          apiUrl = API_URLS.GET_GROUP_MEMBER_DASHBOARD(
            "emission_tracking",
            selectedMemberId,
          );
        } else {
          apiUrl = API_URLS.GET_SDG_DASHBOARD("emission_tracking");
        }

        const queryParams = new URLSearchParams();
        if (yearFilter) queryParams.append("year", yearFilter);
        if (locationFilter) queryParams.append("locationId", locationFilter);
        if (departmentFilter)
          queryParams.append("departmentId", departmentFilter);
        const queryString = queryParams.toString()
          ? `?${queryParams.toString()}`
          : "";
        console.log("🔥 Fetching Dashboard API:", apiUrl + queryString); // ADDED LOG
        apiUrl += queryString;

        // console.log("Emission Tracking API Hit:", apiUrl);
        const res = await getApi({
          apiUrl: apiUrl,
        });
        // console.log("Emission Tracking Response:", res);
        if (res?.data) {
          const data = res.data.dashboard ? res.data.dashboard : res.data;
          setDashboardData(data);
        }
      } catch (error) {
        console.error("Error fetching emission tracking data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboardData();
  }, [
    selectedMemberId,
    activeDashboard,
    yearFilter,
    locationFilter,
    departmentFilter,
  ]);

  useEffect(() => {
    dispatch(fetchAllLocations());
    dispatch(fetchAllDepartments());
  }, [dispatch]);

  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  // Handle close - only allow closing if permission is completed
  const handlePermissionClose = () => {
    if (isPermissionCompleted) {
      setPermission(false);
    }
    // If not completed, do nothing - modal stays open
  };

  const dashboardSource =
    activeDashboard === "live" ? dashboardData : DUMMY_COMPONENTS;

  const locationOptions = useMemo(
    () =>
      (locationList || []).map((item) => ({
        value: item?._id,
        label: item?.location_name || item?.name || "Unnamed Location",
      })),
    [locationList],
  );

  const departmentOptions = useMemo(
    () =>
      (departmentList || []).map((item) => ({
        value: item?._id,
        label: item?.department_name || item?.name || "Unnamed Department",
      })),
    [departmentList],
  );

  const selectedLocationLabel =
    locationOptions.find((item) => item.value === locationFilter)?.label || "";
  const selectedDepartmentLabel =
    departmentOptions.find((item) => item.value === departmentFilter)?.label ||
    "";

  const getComponent = (id) =>
    activeDashboard === "live"
      ? dashboardData?.components?.find((c) => c.componentId === id)
      : dashboardSource[id];

  const getKpiValue = (id, defaultValue = "0") => {
    const comp = getComponent(id);
    return comp?.data?.value?.toLocaleString() || defaultValue;
  };

  const heatingCoolingComp = getComponent("monthwise_heating_cooling");
  const heatingCoolingSeriesGrouped = useMemo(() => {
    const datasets = heatingCoolingComp?.data?.datasets || [];
    const findVal = (label) => {
      const found = datasets.find(
        (d) => d.label?.toLowerCase() === label.toLowerCase(),
      );
      return found ? found.value : 0;
    };
    return [
      {
        name: "Operational",
        data: [
          findVal("Heating - Operational"),
          findVal("Cooling - Operational"),
        ],
      },
      {
        name: "Installed",
        data: [findVal("Heating - Installed"), findVal("Cooling - Installed")],
      },
      {
        name: "Discarded",
        data: [findVal("Heating - Discarded"), findVal("Cooling - Discarded")],
      },
    ];
  }, [heatingCoolingComp]);

  const refrigeratorComp = getComponent("monthwise_refrigerator");
  const refrigeratorSeriesGrouped = useMemo(() => {
    const datasets = refrigeratorComp?.data?.datasets || [];
    const findVal = (label) => {
      const found = datasets.find(
        (d) => d.label?.toLowerCase() === label.toLowerCase(),
      );
      return found ? found.value : 0;
    };
    return [
      {
        name: "Operational",
        data: [findVal("Operational")],
      },
      {
        name: "Installed",
        data: [findVal("Installed")],
      },
      {
        name: "Discarded",
        data: [findVal("Discarded")],
      },
    ];
  }, [refrigeratorComp]);

  const getChartData = (id) => {
    const comp = getComponent(id);
    const apiLabels = comp?.data?.labels || [];
    const apiValues = comp?.data?.values || [];
    const datasets = comp?.data?.datasets || [];

    const categories = apiLabels.length > 0 ? apiLabels : MONTH_LABELS;

    let series = [];
    if (comp?.data?.series) {
      series = comp.data.series;
    } else if (datasets.length > 0) {
      let filteredDatasets = datasets;
      if (id === "monthwise_business_travel") {
        filteredDatasets = datasets.filter(
          (ds) => ds.label?.toLowerCase() !== "total",
        );
      } else if (id === "monthwise_purchased_electricity") {
        const totalDatasets = datasets.filter(
          (ds) => ds.label?.toLowerCase() === "total",
        );
        filteredDatasets = totalDatasets.length > 0 ? totalDatasets : datasets;
      }
      series = filteredDatasets.map((ds) => ({
        name: ds.label,
        data: ds.data,
      }));
    }

    // Ensure values match categories length
    let values = apiValues;
    if (values && values.length > 0) {
      if (values.length < categories.length) {
        const padding = new Array(categories.length - values.length).fill(0);
        values = [...values, ...padding];
      }
      if (series.length === 0) {
        series = [{ name: comp?.title || "Data", data: values }];
      }
    }

    return {
      labels: categories,
      values: values,
      categories: categories,
      series: series,
    };
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#F5F5F5]">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-[#458276]"></div>
      </div>
    );
  }

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-10 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}

      <TimeFilterBar
        title="Emission Tracking"
        showBreadcrumb={true}
        breadcrumbItems={["Home", "Emission Tracking"]}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
        activeDashboard={activeDashboard}
        onDashboardChange={setActiveDashboard}
        customFilters={
          user?.orgStructureMode === "department-first"
            ? [
                {
                  key: "department",
                  label: "Department",
                  valueLabel: selectedDepartmentLabel || "Department",
                  options: departmentOptions,
                  onChange: setDepartmentFilter,
                },
                {
                  key: "location",
                  label: "Location",
                  valueLabel: selectedLocationLabel || "Location",
                  options: locationOptions,
                  onChange: setLocationFilter,
                },
              ]
            : [
                {
                  key: "location",
                  label: "Location",
                  valueLabel: selectedLocationLabel || "Location",
                  options: locationOptions,
                  onChange: setLocationFilter,
                },
                {
                  key: "department",
                  label: "Department",
                  valueLabel: selectedDepartmentLabel || "Department",
                  options: departmentOptions,
                  onChange: setDepartmentFilter,
                },
              ]
        }
        onYearChange={setYearFilter}
        selectedYearValue={yearFilter}
      />

      <div
        className={` ${
          !isPermissionCompleted ? "blur-sm opacity-20 pointer-events-none" : ""
        }`}
      >
        {/* <div className="flex items-center justify-end pb-2">
          <span className="text-xs font-medium text-[#06513D]">
            {activeDashboard === "live"
              ? "Live dashboard selected"
              : "Dummy dashboard selected"}
          </span>
        </div> */}

        <div className="flex flex-col lg:flex-row gap-4 items-stretch mt-4">
          {/* ScopeWiseFootprint box */}
          <div className="w-full lg:w-4/5  border border-[#3da3baa9] rounded-lg">
            <ScopeWiseFootprint
              apiData={
                getComponent("scope_wise_footprint")?.data
                  ? [
                      {
                        scope: 1,
                        emission:
                          getComponent("scope_wise_footprint")?.data
                            ?.values?.[0] || 0,
                        percentage:
                          getComponent("scope_wise_footprint")?.data
                            ?.percentages?.[0] || 0,
                        color: "#E8C458",
                      },
                      {
                        scope: 2,
                        emission:
                          getComponent("scope_wise_footprint")?.data
                            ?.values?.[1] || 0,
                        percentage:
                          getComponent("scope_wise_footprint")?.data
                            ?.percentages?.[1] || 0,
                        color: "#6AA4F7",
                      },
                      {
                        scope: 3,
                        emission:
                          getComponent("scope_wise_footprint")?.data
                            ?.values?.[2] || 0,
                        percentage:
                          getComponent("scope_wise_footprint")?.data
                            ?.percentages?.[2] || 0,
                        color: "#06513D",
                      },
                    ]
                  : null
              }
            />
          </div>

          {/* CarbonCard box */}
          <div className="w-full lg:w-[46%]">
            <CarbonCard
              icon={<DashboardIcon />}
              title="Total Carbon Footprint"
              value={getKpiValue("total_carbon_footprint")}
              description="Mtco2e"
              descriptionBgColor="#06513D"
              ClassName="text-center"
              descriptionClassName="text-center"
            />
          </div>
        </div>

        {/* Second Row */}
        <div className="flex flex-col lg:flex-row gap-4 items-stretch mt-4">
          {/* BarChart box */}
          <div className="w-full lg:w-4/5 border border-[#3da3baa9] rounded-lg">
            <BarChart
              icon={<Waterfootprint />}
              title="Month wise Water Footprint"
              categories={getChartData("monthwise_water_footprint").categories}
              data={getChartData("monthwise_water_footprint").values}
              legend="Water Use (Litres)"
              xAxisTitle="Month"
              yAxisTitle={["Water Consumption", "       (in kilolitres)"]}
            />
          </div>

          {/* CarbonCard box */}
          <div className="w-full lg:w-[46%]">
            <CarbonCard
              icon={<Waterfootprint />}
              title="Total Water Footprint"
              value={getKpiValue("total_water_footprint")}
              description="Kilolitres"
              descriptionBgColor="#06513D"
              ClassName="text-center"
              descriptionClassName="text-center"
            />
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 items-stretch mt-4">
          <PieChart
            icon={<Icon3 />}
            title="Scope 1 & 2 "
            series={
              getComponent("scope_1_2_pie")?.data?.map((d) => d.value) || [
                0, 0, 0, 0, 0,
              ]
            }
            values={
              getComponent("scope_1_2_pie")?.data?.map((d) => d.value) || [
                0, 0, 0, 0, 0,
              ]
            }
            labels={
              getComponent("scope_1_2_pie")?.data?.map((d) => d.group) || [
                "Purchased Electricity",
                "Fugitive emissions",
                "Stationary Fuel Consumption",
                "Mobile Fuel Combustion",
                "Purchased Heat & Steam",
              ]
            }
            dataLabelsOutside={true}
          />
        </div>

        {/* <div className="flex mx-6 bg-white rounded-2xl gap-x-5 border border-[#3DA3BA59]  "> */}
        <div className="flex flex-col bg-white rounded-2xl lg:flex-row gap-4 items-stretch mt-4 border border-[#3da3baa9]  ">
          <StackedBarChart
            icon={<Mobliefuel1 />}
            height={500}
            title={
              getComponent("monthwise_business_travel")?.title ||
              "Month-wise Emission from Business Travel"
            }
            categories={getChartData("monthwise_business_travel").categories}
            series={getChartData("monthwise_business_travel").series}
            colors={["#458276", "#6AA4F7", "#E8C458", "#EAA89D"]}
          />

          <StackedBarChart
            icon={<Moblefuel2 />}
            title={
              getComponent("monthwise_vehicle_fuel")?.title ||
              "Monthwise emission from vehicle fuel usage"
            }
            height={500}
            categories={getChartData("monthwise_vehicle_fuel").categories}
            series={getChartData("monthwise_vehicle_fuel").series}
            colors={["#458276", "#6AA4F7", "#E8C458", "#EAA89D"]}
          />
        </div>

        <div className="flex flex-col bg-white rounded-2xl mt-4 lg:flex-row gap-4 items-stretch  border border-[#3da3baa9]   ">
          <StackedBarChart
            icon={<Mobliefuel1 />}
            heading="Scope 1"
            titles="Stationary Fuel Consumption"
            title={
              getComponent("monthwise_stationary_fuel")?.title ||
              "Month wise Emission from Cooking/Power generators/Agriculture Fuel/ Other Fuel Usage"
            }
            categories={getChartData("monthwise_stationary_fuel").categories}
            series={getChartData("monthwise_stationary_fuel").series}
            colors={["#458276", "#6AA4F7", "#E8C458", "#EAA89D"]}
          />

          <StackedBarChart
            icon={<Monthwise2 />}
            title={
              getComponent("monthwise_renewable_savings")?.title ||
              "Month wise Emission savings from Onsite Renewable Power Generation"
            }
            categories={getChartData("monthwise_renewable_savings").categories}
            series={getChartData("monthwise_renewable_savings").series}
            colors={["#458276", "#6AA4F7", "#E8C458", "#EAA89D", "#53ADC1"]}
          />
        </div>

        <div className="flex flex-col lg:flex-row gap-4 items-stretch mt-4">
          <GroupedColumnChart
            icon={<Monthwise11 />}
            title={
              getComponent("monthwise_heating_cooling")?.title ||
              "Month wise emission from heating & cooling system"
            }
            categories={["Heating", "Cooling"]}
            series={(() => {
              const srcSeries = heatingCoolingSeriesGrouped || [];
              if (!srcSeries || srcSeries.length === 0) return srcSeries;
              const allVals = srcSeries.flatMap((s) => s.data || []);
              const realMax = Math.max(
                ...allVals.map((v) =>
                  typeof v === "object" ? (v.y ?? v.value ?? 0) : v || 0,
                ),
                0,
              );
              const minFraction = 0.02;
              const minAbsolute = 0.005;
              const minDisplay = Math.max(realMax * minFraction, minAbsolute);

              return srcSeries.map((s) => {
                const orig = (s.data || []).map((v) =>
                  typeof v === "object" ? (v.y ?? v.value ?? 0) : v || 0,
                );
                const dataForRender = orig.map((v) => {
                  if (v === 0) return minDisplay * 0.1;
                  if (v > 0 && v < minDisplay) return minDisplay;
                  return v;
                });
                return { ...s, originalValues: orig, data: dataForRender };
              });
            })()}
            colors={["#458276", "#6AA4F7", "#E8C458"]}
            yAxisLabel="in Mtco2e"
            strokeWidth={0}
          />

          <GroupedColumnChart
            icon={<Monthwise22 />}
            title={
              getComponent("monthwise_refrigerator")?.title ||
              "Month wise emission from refrigerator"
            }
            categories={["Refrigerator"]}
            series={(() => {
              const srcSeries = refrigeratorSeriesGrouped || [];
              if (!srcSeries || srcSeries.length === 0) return srcSeries;
              const allVals = srcSeries.flatMap((s) => s.data || []);
              const realMax = Math.max(
                ...allVals.map((v) =>
                  typeof v === "object" ? (v.y ?? v.value ?? 0) : v || 0,
                ),
                0,
              );
              const minFraction = 0.02;
              const minAbsolute = 0.005;
              const minDisplay = Math.max(realMax * minFraction, minAbsolute);

              return srcSeries.map((s) => {
                const orig = (s.data || []).map((v) =>
                  typeof v === "object" ? (v.y ?? v.value ?? 0) : v || 0,
                );
                const dataForRender = orig.map((v) => {
                  if (v === 0) return minDisplay * 0.1;
                  if (v > 0 && v < minDisplay) return minDisplay;
                  return v;
                });
                return { ...s, originalValues: orig, data: dataForRender };
              });
            })()}
            colors={["#458276", "#6AA4F7", "#E8C458"]}
            yAxisLabel="in Mtco2e"
            columnWidth="14%"
            strokeWidth={0}
          />
        </div>

        <div className="bg-white rounded-2xl mt-4 border border-[#3da3baa9] p-4">
          <h2 className="text-lg font-bold font-calibri text-green-700 mb-2">
            Scope 2
          </h2>
          <div className="flex flex-col  lg:flex-row gap-4 items-stretch    ">
            <VerticalBarChart
              icon={<Scopemonth />}
              title={
                getComponent("monthwise_purchased_electricity")?.title ||
                "Month wise emission from purchased electricity"
              }
              categories={
                getChartData("monthwise_purchased_electricity").categories
              }
              data={getChartData("monthwise_purchased_electricity").values}
              series={
                // Ensure very small values are visible by providing a display-series
                // that bumps tiny values up for rendering while preserving originals
                (() => {
                  const purchased = getChartData(
                    "monthwise_purchased_electricity",
                  );
                  const srcSeries = purchased.series || [];
                  if (!srcSeries || srcSeries.length === 0) return srcSeries;
                  const allVals = srcSeries.flatMap((s) => s.data || []);
                  const realMax = Math.max(
                    ...allVals.map((v) =>
                      typeof v === "object" ? (v.y ?? v.value ?? 0) : v || 0,
                    ),
                    0,
                  );
                  const minFraction = 0.02; // 2% of max
                  const minAbsolute = 0.005; // floor absolute minimum
                  const minDisplay = Math.max(
                    realMax * minFraction,
                    minAbsolute,
                  );

                  return srcSeries.map((s) => {
                    const orig = (s.data || []).map((v) =>
                      typeof v === "object" ? (v.y ?? v.value ?? 0) : v || 0,
                    );
                    const dataForRender = orig.map((v) => {
                      // keep larger values unchanged, bump tiny positives; keep zeros tiny but visible
                      if (v === 0) return minDisplay * 0.1;
                      if (v > 0 && v < minDisplay) return minDisplay;
                      return v;
                    });
                    return { ...s, originalValues: orig, data: dataForRender };
                  });
                })()
              }
              legend="Emission from Purchased Electricity (Mtco2e)"
              xAxisTitle="Month"
              yAxisTitle="in Mtco2e"
              showPercentage={false}
              roundDataLabels={true}
              showLegend={false}
              colors={["#458276", "#458276", "#458276", "#458276"]}
              height={320}
            />
            <LineChart
              icon={<Scopemonth />}
              title={
                getComponent("monthwise_heat_steam")?.title ||
                "Month wise emission from purchased Heat & Steam"
              }
              categories={getChartData("monthwise_heat_steam").categories}
              data={getChartData("monthwise_heat_steam").values}
              series={getChartData("monthwise_heat_steam").series}
              legend="Emission from Purchased Heat & Steam (Mtco2e)"
              showPercentage={false}
              height={320}
              yAxisConfig={{
                min: 0,
              }}
            />
          </div>
        </div>

        <div className="flex flex-col bg-white rounded-2xl mt-4 lg:flex-row gap-4 items-stretch  border border-[#3da3baa9]   ">
          <LabelValueCard
            title="T & D LOSS"
            value={getKpiValue("t_and_d_loss")}
          />
        </div>

        <div className=" rounded-2xl border border-[#3da3baa9] mt-4 ">
          <HorizontalBarChart
            title="Scope 3 "
            icon={<Scope3 />}
            categories={getChartData("scope_3_horizontal_bar").categories}
            data={getChartData("scope_3_horizontal_bar").values}
            details={getChartData("scope_3_horizontal_bar").values.map(
              (v, i) => ({
                value: v,
                percent: `${getComponent("scope_3_horizontal_bar")?.data?.percentages?.[i] || 0}%`,
              }),
            )}
            valueLabel="Emissions (Mtco2e)"
            percentLabel="Share (%)"
            tooltipUnit="Mtco2e"
            xh="In Mtco2e"
            yh="scope 3 categories"
          />
        </div>

        {/* <div className="flex flex-col  rounded-2xl mt-4 lg:flex-row gap-4 items-stretch     ">
        <div className="   border border-[#3da3baa9]    rounded-lg bg-white">
          <ProgressChart
            icon={<Eng2 />}
            categories={["LCA done till date", "Remaining Products"]}
            title="LCA (Total Products vs LCA Till date)"
            mainLabel="LCA done till date"
            mainValue={0}
            totalValue={0}
            primaryColor="#167F94"
            secondaryColor="#A8D1DA"
            primaryLegendLabel="Total Products"
            secondaryLegendLabel="LCA done till date"
            legendPosition="right"
            className=" p-5"
            lacvalue="LCA done till date"
            chartContainerClassName="  pl-1 "
            barHeights={100}
            barwidth={100}
            style={{ border: "1px solid red" }}
          />
        </div>
        <div>
          <DonutChart
            icon={<Eng1 />}
            title="Clean Energy (Target vs Achievement)"
            target={100}
            achievement={45}
            heightclass="h-[100%]"
          />
        </div>
      </div> */}

        <div className="flex flex-col lg:flex-row gap-4 items-stretch mt-4">
          {/* ProgressChart Container */}
          <div className="w-full lg:w-1/2 border border-[#3da3baa9] rounded-lg bg-white flex flex-col">
            <ProgressChart
              icon={<Eng2 />}
              categories={["LCA done till date", "Remaining Products"]}
              title="LCA (Total Products vs LCA Till date)"
              mainLabel="LCA done till date"
              mainValue={getComponent("lca_ring")?.data?.lcaDone || 0}
              totalValue={getComponent("lca_ring")?.data?.totalProducts || 0}
              primaryColor="#06513D"
              secondaryColor="#E6EEEC"
              primaryLegendLabel="Total Products"
              secondaryLegendLabel="LCA done till date"
              legendPosition="right"
              className="p-5 flex-grow"
              lacvalue="LCA done till date"
              chartContainerClassName="pl-1"
              barHeights={100}
              barwidth={100}
            />
          </div>

          {/* DonutChart Container */}
          <div className="w-full lg:w-1/2  rounded-lg bg-white">
            <DonutChart
              icon={<Eng1 />}
              title="Clean Energy (Target vs Achievement)"
              target={getComponent("clean_energy_ring")?.data?.target || 0}
              achievement={
                getComponent("clean_energy_ring")?.data?.achievement || 0
              }
              heightclass="h-full w-full"
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-3 mt-4 mb-20 sm:mb-40 md:mb-40 lg:mb-1">
          <CarbonSmallCard
            icon={<Product1 />}
            title="Employee Emission Intensity"
            value={`${getComponent("employee_emission_intensity")?.data?.intensity?.toFixed(2) || "0.00"} Mtco2e/employee`}
            description={`Total Employees ${getComponent("employee_emission_intensity")?.data?.denominator || 0}`}
            descriptionBgClass="bg-[#458276]"
            // empvalue="per employee"
          />

          <CarbonSmallCard
            icon={<Product2 />}
            title={
              getComponent("area_emission_intensity")?.title ||
              "Area Emission Intensity"
            }
            value={`${getComponent("area_emission_intensity")?.data?.intensity?.toFixed(2) || "0.00"} Mtco2e/sq.ft`}
            description={`Total Area ${getComponent("area_emission_intensity")?.data?.denominator || 0} Sq.Ft.`}
            descriptionBgClass="bg-[#458276]"
            // empvalue="per square feet"
          />

          <CarbonSmallCard
            icon={<Product3 />}
            title={
              getComponent("revenue_emission_intensity")?.title ||
              "Revenue Emission Intensity"
            }
            value={`${getComponent("revenue_emission_intensity")?.data?.intensity?.toFixed(2) || "0.00"} Mtco2e/crore`}
            description={`Total Revenue ${getComponent("revenue_emission_intensity")?.data?.denominator || 0} cr.`}
            descriptionBgClass="bg-[#458276]"
            // empvalue="per crore"
          />

          <CarbonSmallCard
            icon={<Product4 />}
            title={
              getComponent("product_emission_intensity")?.title ||
              "Product Emission Intensity"
            }
            value={`${getComponent("product_emission_intensity")?.data?.intensity?.toFixed(2) || "0.00"} Mtco2e/product`}
            description={`Total Product ${getComponent("product_emission_intensity")?.data?.denominator || 0}`}
            descriptionBgClass="bg-[#458276]"
            // empvalue="per product"
          />
        </div>
      </div>
    </div>
  );
};

export default memo(EmissionDashboard);
